"use client";

import React, { useState } from "react";
import { Box, styled, Typography } from "@mui/material";
import { SkillLogo } from "@components/Floats/parts/SkillLogo";
import {
  SectionHeader,
  SectionContent,
  RightColumn,
} from "./styles/SharedStyles";
import EditSkills from "../modals/EditSkills";
import EditButton from "@components/shared/EditButton";
import {
  useAddCandidateSkill,
  useRemoveCandidateSkill,
} from "@lib/candidates/useSkillMutations";
import { SkillsSkeleton } from "./skeletons/SkillsSkeleton";

const SkillsGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(185px, 1fr))",
  rowGap: "15px",
}));

const Skill = styled(Box)({
  display: "flex",
  alignItems: "center",
  minHeight: "26px",
});

const Pill = styled(Box)({
  width: "90%",
  display: "flex",
  alignItems: "center",
  borderRadius: "9999px",
  border: "1px solid black",
  padding: "8px 13px",
});

const Description = styled(Typography)({
  fontSize: "12px",
  fontWeight: 400,
  marginLeft: "8px",
});

const Skills = ({ candidate, isImporting }) => {
  const [openEditSkills, setOpenEditSkills] = useState(false);
  const addSkill = useAddCandidateSkill();
  const removeSkill = useRemoveCandidateSkill();

  const handleAddSkill = (skill) => {
    addSkill.mutate({ candidate, skill });
  };

  const handleRemoveSkill = (skillId) => {
    removeSkill.mutate({ candidate, skillId });
  };

  return (
    <>
      <Box id="candidate-section-skills">
        <SectionContent>
          <EditButton
            onEdit={() => setOpenEditSkills(true)}
            sx={{ top: 0, right: 0 }}
          />
          <Box>
            <RightColumn>
              <SectionHeader>
                <Typography variant="h2">Skills</Typography>
              </SectionHeader>
              {isImporting ? (
                <SkillsSkeleton />
              ) : (
                <SkillsGrid>
                  {candidate.skills?.map((skill) => (
                    <Skill key={skill.id}>
                      <Pill>
                        {skill.logo && (
                          <SkillLogo
                            sx={{ width: 20, height: 20 }}
                            src={skill.logo}
                            variant="square"
                            title={skill.name}
                            alt={skill.name}
                          />
                        )}
                        <Description variant="body2">{skill.name}</Description>
                      </Pill>
                    </Skill>
                  ))}
                  {candidate.skills?.length === 0 && (
                    <Box sx={{ mt: 2, mb: 2, fontStyle: "italic" }}>
                      No skills selected
                    </Box>
                  )}
                </SkillsGrid>
              )}
            </RightColumn>
          </Box>
        </SectionContent>
      </Box>
      <EditSkills
        open={openEditSkills}
        onClose={() => setOpenEditSkills(false)}
        candidate={candidate}
        onAdd={handleAddSkill}
        onRemove={handleRemoveSkill}
      />
    </>
  );
};

export default Skills;
